<template>
    <div class="froot">
        <div class="h">
        <h1 v-on:click="IncrementCounter">{{ customername }}
            <h2><b>Code Version:</b> {{ version }}</h2>
        </h1>
        </div>
        <div class="buttons">
            <div class="button" v-on:click="ExecCMD('shutdown')" v-if="!showVersionNeg">
                <div class="button-image"><i class="fas fa-power-off"></i></div>
                <div class="button-text">{{ translation["STR_SHUTDOWN"] }}</div>
            </div>

            <div class="button" v-on:click="Reload()" v-if="showVersionNeg">
                <div class="button-image"><i style="color: #ff4800;" class="fas fa-sync-alt"></i></div>
                <div class="button-text" style="color: #ff4800;">Ger&auml;t aktualisieren</div>
            </div>
            

            <div class="button" v-on:click="GoTo('StartScreen')">
                <div class="button-image"><i class="fas fa-vial"></i></div>
                <div class="button-text">{{ translation["STR_NEW_TEST"] }}</div>
            </div>
            
            <!--
            <div class="button" v-on:click="GoTo('admin')">
                <div class="button-image"><i class="fas fa-flag"></i></div>
                <div class="button-text">{{ translation["STR_STATISTICS"] }}</div>
            </div>
            -->

            <div class="button" v-on:click="ExecCMD('openlid')">
                <div class="button-image"><i class="fas fa-arrow-circle-up"></i></div>
                <div class="button-text">{{ translation["STR_OPENLID"] }}</div>
            </div>

        </div>
    </div>
</template>
<style scoped>
.h {
    width: 100%;
}
.froot {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
}
.buttons {
    margin: auto;
    color: var(--primary-color);
    display: flex;
    width: 100%;
    margin: auto;
    justify-content: center;
}
.button {
    display: flex;
    flex-direction:column;
    padding-right: 90px;
    cursor: pointer;
}
.button-image {
    font-size: 120px;
    height: 200px;
}
.button-text {
    text-align: center;
    font-size: 12pt;
}

h1 h2 {
    font-size: 10pt;
    padding: 0px;
    margin: 0px;
}
</style>
<script>
var resetTimer = false;
export default ({
    props: [ 'token', 'customername', 'custid', 'showVersionNeg', 'translation','version' ],
    data() {
        return {
            counter: 0,
        }
    },
    methods: {
        IncrementCounter() {
            if(resetTimer) clearTimeout(resetTimer);
            this.counter++;
            if(this.counter == 10) {
                this.$emit("triggerEasterEgg");
                prompt("Device Token:", this.token)
                this.$emit("adminmodeenabled");
            }
            resetTimer = setTimeout(() => {
                this.counter = 0;
            }, 1500)
        },
        Reload() {
            top.location.reload();
        },
        ExecCMD(cmd) {
            this.axios.get("http://127.0.0.1:8441/procomcure/?cmd="+cmd).catch(() => {})
        },
        GoTo(i) {
            this.$router.push({
                name: i
            })
        }
    }
})
</script>
